import styled from "styled-components";

export const ContainerCriticality = styled.div`
      display: flex;
      flex-direction: row;
      align-items: center;
    `

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  padding: 0.5em;
  border-radius: 10px;
  label {
    font-weight: 700;
  }`
export const InputsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-between;
  width: 80%;
  label > input {
    opacity: 0;
    position: absolute;
  }

  label > input + div {
    display: flex;
    border-radius: 50px;
    width: 7em;
    height: 2.5em;
    border-width: 1px;
    border-style: solid;
    border-color: var(--color-purple);
    background-color: transparent;
    justify-content: space-evenly;
    align-items: center;
    margin-right: 0.5em;
    font-size: 0.9em;
    cursor: pointer;
  
  }

  label > input:checked + div {
    background-color: var(--color-purple);
    p{
      color: var(--color-white);
    }
  }
`

export const Input = styled.input`
  width: 8em;
  height: 2.5em;
  border-width: 1px;
  border-style: solid;
  padding: 0.5em;
  border-color: rgba(166, 172, 181, 0.3);
  background-color: transparent;
  cursor: pointer;

  &:hover {
    background-color: rgba(166, 172, 181, 0.3);
  }
`

